const STORAGE_KEY = 'zotzon.redundant-media-preferences.v1';
const DEFAULT_TTL_MS = 10 * 60 * 1000;

const isBrowser = typeof window !== 'undefined';

const readPreferences = () => {
  if (!isBrowser) return {};

  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch {
    return {};
  }
};

const writePreferences = (value) => {
  if (!isBrowser) return;

  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(value));
  } catch {
    // Ignore storage quota / privacy-mode failures.
  }
};

const cleanupExpired = (preferences) => {
  const now = Date.now();
  const next = { ...preferences };
  Object.entries(next).forEach(([key, item]) => {
    if (!item?.expiresAt || item.expiresAt <= now) {
      delete next[key];
    }
  });
  return next;
};

export const rememberMediaPriority = (preferenceKey, priority, ttlMs = DEFAULT_TTL_MS) => {
  if (!preferenceKey || !priority) return;

  const next = cleanupExpired(readPreferences());
  next[preferenceKey] = {
    priority,
    expiresAt: Date.now() + ttlMs,
  };
  writePreferences(next);
};

export const getRememberedMediaPriority = (preferenceKey) => {
  if (!preferenceKey) return null;

  const next = cleanupExpired(readPreferences());
  writePreferences(next);
  return next[preferenceKey]?.priority || null;
};

export const getOrderedMediaCandidates = ({ primaryUrl, backupUrl, preferenceKey }) => {
  const primary = typeof primaryUrl === 'string' && primaryUrl.trim() ? primaryUrl.trim() : null;
  const backup = typeof backupUrl === 'string' && backupUrl.trim() ? backupUrl.trim() : null;

  if (!primary && !backup) return [];
  if (!backup || backup === primary) return primary ? [{ url: primary, role: 'primary' }] : [];

  const remembered = getRememberedMediaPriority(preferenceKey);
  if (remembered === 'backup') {
    return [
      { url: backup, role: 'backup' },
      { url: primary, role: 'primary' },
    ];
  }

  return [
    { url: primary, role: 'primary' },
    { url: backup, role: 'backup' },
  ];
};

export { DEFAULT_TTL_MS };

